import BaseIconSvg from '@/components/bases/BaseIconSvg';
import constants from '@/constants';
import DetailContent from '@/screens/Timeline/components/DetailContent';
import useGlobalConfigs from '@/stores/globalConfigs';
import quickModal from '@/utils/quickModal';
import dayjs from 'dayjs';
import * as React from 'react';

export interface ICardHealthRecordProps {
  healthRecord: IEMRData;
}

const CardHealthRecord: React.FC<ICardHealthRecordProps> = ({ healthRecord, ...props }) => {
  const day = dayjs(healthRecord.date);
  const getEmrType = useGlobalConfigs((s) => s.getEmrType);
  let isWarning = false;

  const DivIcd = (
    <div className="empty:hidden mt-2">
      {healthRecord?.data?.icd?.map((icd: any, i: number) => {
        if (['genetic', 'infection'].includes(icd?.data?.group)) {
          isWarning = true;
        }
        return (
          <div key={i.toString()} className="font-semibold mb-1">
            {icd?.data?.icd?.label} | {icd?.data?.definiteDiagnosis}
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      className="bg-white w-full h-full rounded-md shadow p-2 cursor-pointer"
      onClick={() => {
        quickModal.custom({
          width: 900,
          title: 'Hồ sơ bệnh án',
          content: <DetailContent emrType={getEmrType(healthRecord.type.code)} emr={healthRecord} />,
        });
      }}
    >
      <div className="flex justify-between gap-2">
        <div>{day.format(constants.DATE_FORMAT)}</div>{' '}
        <div>
          {isWarning && (
            <BaseIconSvg
              src="/icons/Regular/Warning - icon.svg"
              className="wh-[16px] text-white bg-red-500 rounded-xl p-0.5 mr-1 flex-none"
            />
          )}
        </div>
      </div>

      {DivIcd}

      <div className="flex items-center gap-2">
        <BaseIconSvg className="" src="/icons/Regular/Medical Services - icon.svg" /> DVKT:{' '}
        <b className="">{healthRecord?.data?.service?.[0]?.data?.service?.length || 0}</b>
      </div>
      <div className="flex items-center gap-2">
        <BaseIconSvg className="" src="/icons/Regular/Vial - icon.svg" /> Xét nghiệm:{' '}
        <b className=""> {healthRecord?.data?.test?.[0]?.data?.test?.length || 0}</b>
      </div>
    </div>
  );
};
export default CardHealthRecord;
